import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

import VueResource from 'vue-resource'
import BootstrapVue from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/adminlte.css'

import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { faBars, faAngleLeft, faHome, faMapMarker, faThList, faColumns, faTint, faMap, faMapPin,
  faCaretLeft, faCalendarWeek, faMinus, faPlus, faEye, faChartLine, faDownload, faThermometerEmpty } from '@fortawesome/free-solid-svg-icons'
import { faStackOverflow, faWpforms } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faBars, faAngleLeft, faHome, faMapMarker, faThList, faColumns, faTint, faMap, faStackOverflow, faWpforms, faMapPin,
  faCaretLeft, faCalendarWeek, faMinus, faPlus, faEye, faChartLine, faDownload, faThermometerEmpty)

Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.component('fa-icon', FontAwesomeIcon)
dom.watch()

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
